var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex"}},_vm._l((_vm.modalities.split('/')),function(modality){return _c('app-modality',{key:modality,attrs:{"modality":modality}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }